export default (
  value: string | number | null | undefined,
  isCurrency = false,
) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return isCurrency
    ? Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: 'PLN',
        useGrouping: true,
        currencyDisplay: 'narrowSymbol',
      }).format(Number(value))
    : Intl.NumberFormat('pl-PL', { useGrouping: true }).format(Number(value));
};
